import { Box, Card, CardContent, Grid, List, ListItem, Typography } from "@mui/material";
import { Modal, Upload } from "antd";
import React, { useContext, useEffect, useState } from "react";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { DeleteOutlined } from '@ant-design/icons';
import { LeftCircleFilled } from '@ant-design/icons';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import MUIButton from "../../shared/components/MUIButton";
import TestCaseHeader from "../testCaseHeader";
// import { useUploadTestCaseDataMutation } from "../../redux/uploadTestcase/uploadTestcase.api";
import InboundOutboundDropdown from "../onboarding/InboundOutboundDropdown";
import MessageTypeDropdown from "../Dashboard/MessageTypeDropdown";
import { SnackbarContext } from "../../shared/context/SnackbarContext.Context";
import { ALERT_SEVERITY, APP_ROUTE_KEYS } from "../../shared/constants/constants";
import PayaptLoader from '../../shared/components/Spinner';
import { useNavigate } from "react-router-dom";
import UploadMessageDropdown from "./UploadMessageDropdown";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useSaveTestcaseforCustomerMutation } from "../../redux/uploadTestcase/uploadTestcase.api";
import { useSelector } from "react-redux";
import { DropdownValueContext } from "../../shared/context/DropdownProvider";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import UploadIcon from '@mui/icons-material/Upload';

const { Dragger } = Upload;
const styles = {
    uploadButtonContainer: {
        textTransform: 'none',
        fontSize: "16px",
        fontFamily: "Inter",
        fontWeight: 600,
        backgroundColor: 'transparent',
        color: '#009966',
        borderColor: "#009966",
        border: ' 1px solid #009966',
        height: 40
    },
    draggerContainer: {
        minHeight: '35vh',
        maxHeight: '50vh',
        minWidth: "60%",
        borderRadius: '20px'
    },
    floatingActionFlexFiveContainer: {
        flex: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'
    }
}
const TestFileUpload = () => {
    const Snackbar = useContext(SnackbarContext);
    const { value, customer } = useContext(DropdownValueContext);
    const { customerId } = useSelector((state) => state?.common);
    const { userRole } = useSelector((state) => state?.common?.userDetails);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [messageType, SetMessgaeType] = useState('Message Type');
    const [inboundOrOutboundValue, setInboundOrOutboundValue] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const formData = new FormData();
    const token = localStorage.getItem('jwttoken');


    const handleModalVisible = (isVisible) => {
        setModalVisibility(isVisible)
    }

    const handleDelete = () => {
        setSelectedFile(null);
        setFileList([]);
    };

    const handleCancel = () => {
        // navigate(`${APP_ROUTE_KEYS.TEST_CASES_REPO.MASTER}`)
        setSelectedFile(null);
        setFileList([]);
        SetMessgaeType(null);
        setInboundOrOutboundValue(null);
    };
    const handleFileChange = (file) => {
        setSelectedFile(file);
        setFileList([
            {
                uid: file.uid,
                name: file.name,
                status: 'done',
                url: URL.createObjectURL(file),
            },
        ]);
    };

    const handleUpload = (file) => {
        console.log('file', file);
        formData.append('customerId', (userRole?.name === 'Admin' || userRole?.name === 'Tester') ? customerId : customer)
        formData.append('paymentServiceId', value)
        if (selectedFile) {
            formData.append('inputFile', selectedFile)
        }
        uploadTestCaseData(formData)
    }

    const uploadTestCaseData = () => {
        setIsLoading(true)
        // formData.append('file', selectedFile);

        // Make the API request with the form data 
        //Simulator/uploadTestCaseDataLatest
        fetch(`${window.REACT_APP_BASE_URL}Payapt/api/v1/AchTestFileUpload/SaveAchTestfileUpload`, {
            method: 'POST',
            body: formData,
            // mode:'no-cors',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => response.json())
            .then(res => {
                // console.log('response', res);
                if (res.status == "SUCCESS") {
                    setIsLoading(false)
                     Snackbar.displayMsg(`File Upload Sucessfully.`, ALERT_SEVERITY.SUCCESS);
                }
                else if (res.debugMessage == "empty sheet") {
                    setIsLoading(false)
                    Snackbar.displayMsg("File is Empty Upload Again", ALERT_SEVERITY.ERROR);
                }
                else {
                    setIsLoading(false)
                    Snackbar.displayMsg(res?.message, ALERT_SEVERITY.ERROR);

                }
            })
            .catch(error => {
                // Handle any network errors
                console.error('Upload error:', error);
                Snackbar.displayMsg(`File Upload Failed.`, ALERT_SEVERITY.ERROR);
            });
        setSelectedFile(null)
        setFileList([])
        formData.delete('inputFile')
    }


    return (
        <Box sx={{ overflowY: 'auto', height: `calc(100vh - 100px)`, paddingBottom: "30px" }}>
            <TestCaseHeader
                title="Test File Upload"
                subtitle="Upload your Test Files"
                showTestCustomer={{
                    show: true,
                }}
            />
            {isLoading && <PayaptLoader />}
            <Box sx={{ padding: '2%',paddingTop:'8%' }}>
                <Box >
                    {/* <Box display={'flex'} sx={{ justifyContent: 'space-around', padding: '50px' }}> */}
                    <Grid container>
                        <Grid item mt={7.5} width={'22%'}>
                            <Typography sx={{ display: "flex", fontFamily: 'Inter', fontStyle: 'normal', fontWeight: "bold", fontSize: "16px" }}>
                                Test Batch Input File
                            </Typography>
                            <Typography sx={{ display: "flex", fontStyle: 'normal', fontWeight: 60, fontSize: "14px" }}>
                                (Select input file )
                            </Typography>
                        </Grid>
                        <Grid item mx={'20%'} mt={2.5} mb={2.5}>
                            <Dragger style={{ padding: '10px', cursor: 'pointer', width: 300 }}
                                name="file"
                                multiple={false}
                                // beforeUpload={file => {
                                //     handleFileChange(file);
                                //     return false;
                                // }}
                                beforeUpload={file => {
                                    const allowedTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv','text/plain','application/pdf'];
                                    const fileType = file.type;

                                    if (allowedTypes.includes(fileType)) {
                                        handleFileChange(file);
                                    } else {
                                        // Display an error message or perform any desired action for unsupported file types.
                                        // console.log('Unsupported file type');
                                        Snackbar.displayMsg(`Unsupported File Type`, ALERT_SEVERITY.ERROR);
                                    }

                                    return false;
                                }}
                                showUploadList={{
                                    showRemoveIcon: true,
                                    removeIcon: <DeleteOutlined onClick={handleDelete} />,
                                }}
                                itemRender={(originNode, file) => (
                                    <div title={file.name} style={{
                                    maxWidth: '200px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                    }}>
                                    {file.name}
                                    </div>
                                )}
                                maxCount={1}
                                fileList={fileList}
                            >
                                <CloudUploadIcon style={{ fontSize: 38, color: '#808080' }} />
                                <p>Drag & Drop your file here</p>
                            </Dragger>
                        </Grid>
                    </Grid>
                    {/* </Box> */}
                </Box>

                <Box mt={15} sx={{ display: "flex" }} >
                    <MUIButton
                        startIcon={<LeftCircleFilled style={{ fontSize: 18 }} />}
                        title="Cancel"
                        sx={{ backgroundColor: '#F0F2F5', color: '#808080', marginRight: "10px" }}
                        color="inherit"
                        onClick={() => handleCancel()}
                    >
                    </MUIButton>
                    <MUIButton
                        startIcon={<UploadIcon style={{ fontSize: 18, }} />}
                        title="Upload Data"
                        sx={{ margin: "0px 10px" }}
                        // disabled={!selectedFile && !selectedFile2 && !selectedFile3
                        // || !messagePack
                        // }
                        onClick={handleUpload}
                    />
                </Box>
            </Box>
        </Box>
    )

}
export default TestFileUpload;